<tabset class="button-tabs">
  <tab heading="Messages"
    (selectTab)="tabs.messages = true"
    (deselect)="tabs.messages = false">
    <ng-container *ngIf="tabs.messages && programApplication?.id">
      <oes-program-message-window
        [participantOrganization]="user?.organization"
        [program]="program"
        [currentUser]="user"
        [stageOneApplicationId]="programApplication?.id">
      </oes-program-message-window>
    </ng-container>
  </tab>
  <tab heading="Files"
    (selectTab)="tabs.files = true"
    (deselect)="tabs.files = false">
    <ng-container *ngIf="tabs.files">
      <oes-files
        *ngIf="tagTypes"
        [storageKey]="'developerProgramParticipantMessages-' + program?.id"
        [tagTypes]="tagTypes"
        [sharedFiles]="true"
        [autoHeightOverride]="true"
        [accessControl]="accessControl"
        [anotherOrganizationId]="program?.sponsor?.id">
      </oes-files>
    </ng-container>
  </tab>
</tabset>
